

























/* Created- 28 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "SearchResultCount",
		components: { ParticaRowContainer }
	})
export default class SearchResultCount extends Vue {
	@Prop() private count: number; // your data        
	private options: number[] = [25, 50, 100];
	private selected(selected: number, event: any) {
		this.$emit("partica-event", { item: selected, action: eParticaAction.CHANGE_SEARCH_RETURN_COUNT } as ParticaEvent);
	}
}
